import React from "react";
import { Brain, Sparkles, Zap, Star, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const Counselling = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* Hero */}
      <div className="bg-exiser-primary text-white py-24 text-center relative overflow-hidden group">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-exiser-primary z-10" />
        <img
          src="https://images.unsplash.com/photo-1544717305-2782549b5136"
          alt="Counselling"
          className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:scale-105 transition-transform duration-[20s]"
        />

        <div className="relative z-20 max-w-4xl mx-auto px-4">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 px-4 py-1 rounded-full mb-6 backdrop-blur-sm">
            <Star className="w-4 h-4 text-exiser-accent fill-current" />
            <span className="text-xs font-bold uppercase tracking-widest">
              Premium Coaching
            </span>
          </div>
          <h1 className="text-5xl md:text-7xl font-bold uppercase mb-6 drop-shadow-lg leading-none">
            Life & Mindset <span className="text-exiser-accent">Mastery</span>
          </h1>
          <p className="text-xl text-purple-200 font-sans max-w-2xl mx-auto">
            Rewire your thinking, upgrade your confidence, and build the mindset
            to achieve everything you dream of.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-4 py-20">
        <div className="grid md:grid-cols-3 gap-10">

          {/* Card 1 */}
          <div className="bg-white rounded-lg shadow-xl p-8 hover:shadow-2xl transition-all border border-gray-100 group">
            <Brain className="w-16 h-16 text-exiser-primary mb-4 group-hover:scale-110 transition-transform" />
            <h3 className="uppercase font-bold text-xl mb-2 text-gray-900">
              Mind Programming
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Uncover unconscious patterns that limit your growth and rewire
              your thinking using scientific techniques.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-lg shadow-xl p-8 hover:shadow-2xl transition-all border border-gray-100 group">
            <Sparkles className="w-16 h-16 text-exiser-primary mb-4 group-hover:scale-110 transition-transform" />
            <h3 className="uppercase font-bold text-xl mb-2 text-gray-900">
              Personal Breakthroughs
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Experience powerful breakthrough sessions tailored to eliminate
              fears, anxiety, procrastination & low confidence.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-lg shadow-xl p-8 hover:shadow-2xl transition-all border border-gray-100 group">
            <Zap className="w-16 h-16 text-exiser-primary mb-4 group-hover:scale-110 transition-transform" />
            <h3 className="uppercase font-bold text-xl mb-2 text-gray-900">
              Peak Performance
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Build unshakeable confidence, magnetic communication, and a
              high-performance mindset to win in life and business.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Link
            to="/book"
            className="bg-exiser-primary text-white px-10 py-4 uppercase font-bold tracking-widest rounded shadow-lg hover:bg-purple-900 hover:scale-105 transition-all inline-flex items-center gap-2"
          >
            Book a Consultation
          </Link>
          <p className="text-xs text-gray-400 mt-3 italic">
            * Limited premium seats — exclusively for action takers.
          </p>
        </div>

        <div className="mt-16 flex justify-center">
          <Link
            to="/"
            className="flex items-center gap-2 text-exiser-primary font-bold uppercase hover:text-exiser-accent transition-colors group"
          >
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Counselling;